// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectTemplateSchema } from './v1/projectTemplateSchema';

export const listProjectTemplatesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listProjectTemplatesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project templates retrieved successfully
 */
export const listProjectTemplates200Schema = z.array(z.lazy(() => v1ProjectTemplateSchema));

export const listProjectTemplatesQueryResponseSchema = z.lazy(() => listProjectTemplates200Schema);
